<template>
  <div class="modal fade" tabindex="-1" role="dialog" id="update-reminder-modal">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <form @submit.prevent="submit">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">
                &times;
              </span>
            </button>

            <h4 class="modal-title">
              Update Reminder
            </h4>
          </div>

          <loading-spinner v-if="loading"></loading-spinner>

          <div v-else class="modal-body">
            <TextareaFormGroup
                v-model="data.text"
                name="text"
                label="Text"
                :error="(errors.text || [])[0]"
            />

            <SelectFormGroup
                v-model="data.priority"
                name="priority"
                label="Priority"
                :error="getError('priority')"
                :options="[{value: 'high', label: 'High'}, {value: 'medium', label: 'Medium'}, {value: 'low', label: 'Low'}]"
            />

            <DateFormGroup
                v-model="data.remind_at"
                name="remind_at"
                label="Remind At"
                :error="getError('remind_at')"
                format="DD.MM.YYYY HH:mm"
                original-format="YYYY-MM-DD HH:mm"
            />

            <SelectFormGroup
                v-model="data.user_id"
                name="user_id"
                label="User"
                :error="getError('user_id')"
                :options="userOptions"
            />

            <MultiSelectFormGroup
                :value="data.portals.map(portal => portal.id)"
                name="portals"
                label="Portals"
                :error="(errors.portals || [])[0]"
                :options="portalOptions"
                @input="data.portals = $event.map(id => ({id}))"
            />

            <StaticFormGroup
                label="Project"
                :value="data.project_name"
            />
          </div>

          <div class="modal-footer">
            <button type="button" class="btn btn-default" data-dismiss="modal">
              Close
            </button>

            <button type="submit" class="btn btn-black">
              <i class="fa fa-save"></i> Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import http from '@/http'
import moment from 'moment'
import notify from '@/notify'
import Errors from '@/mixins/Errors'
import LoadingSpinner from '@/components/Layout/LoadingSpinner'
import DateFormGroup from '@/vendor/forms/FormGroups/Block/Date'
import SelectFormGroup from '@/vendor/forms/FormGroups/Block/Select'
import StaticFormGroup from '@/vendor/forms/FormGroups/Block/Static'
import TextareaFormGroup from '@/vendor/forms/FormGroups/Block/Textarea'
import MultiSelectFormGroup from "../../../components/FormGroups/Block/MultiSelect.vue";

export default {
  components: {DateFormGroup, LoadingSpinner, MultiSelectFormGroup, SelectFormGroup, StaticFormGroup,TextareaFormGroup},

  mixins: [Errors],

  props: {
    reminder: {}
  },

  data() {
    return {
      data: {
        portals: []
      },

      loading: true,

      users: null,
      portals: null
    }
  },

  mounted() {
    this.listenForClose()

    this.load()
  },

  watch: {
    reminder() {
      this.data = {...this.reminder.attributes}
    },
  },

  computed: {
    userOptions() {
      return this.users.map(user => ({value: user.id, label: user.attributes.full_name}))
    },

    portalOptions() {
      return this.portals.map(portal => ({value: portal.id, label: portal.attributes.name}))
    },
  },

  methods: {
    listenForClose() {
      $(this.$el).on('hidden.bs.modal', this.reset)
    },

    load() {
      Promise.all([
        http.get('/api/v2/users'),
        http.get('/api/v2/portals'),
      ]).then(responses => {
        this.users = responses[0].data.data
        this.portals = responses[1].data.data

        this.loading = false
      })
    },

    submit() {
      http.put('/api/v2/reminders/' + this.reminder.id, {
        ...this.data,
        remind_at: moment(this.data.remind_at).format('YYYY-MM-DD HH:mm:ss'),
      })
          .then(response => {
            notify.success('The reminder was saved')

            this.$emit('updated', response.data.data)

            $(this.$el).modal('hide')
          })
          .catch(this.catchValidationErrors)
    },

    reset() {
      this.errors = {}

      this.data = {...this.reminder.attributes}
    }
  }
}
</script>
